<template>
  <RouterLink :to="`/post/${post.slug}`" class="card">
    <div class="card-image">
      <img :src="post.image" :alt="post.title" />
    </div>
    <div class="card-content">
      <RouterLink :to="`/categoria/${post.category}`" class="card-category">
        {{ post.category }}
      </RouterLink>
      <h4 class="card-title">{{ post.title }}</h4>
      <div class="card-author">
        <span class="ball"></span>
        <span>{{ post.author }}</span>
      </div>
    </div>
  </RouterLink>
</template>

<script>
import Vue from 'vue'
import '@/assets/scss/custom/franquias/components/_post-card-simples.scss'

export default {
  props: {
    post: {
      required: true,
    },
  },
}
</script>
